import { render, staticRenderFns } from "./CustomerListFilter.vue?vue&type=template&id=aa2d71e4&scoped=true&"
import script from "./CustomerListFilter.vue?vue&type=script&lang=js&"
export * from "./CustomerListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2d71e4",
  null
  
)

export default component.exports